import API from 'services/API';

const BANNER_ID = 'BANNER_NOTIFICATION';

export default function getNotifications(params) {
  return API.request({
    method: 'GET',
    url: '/bell/notifications',
    params,
    mapper: createNotificationsIds,
  });
}

function createNotificationsIds(data) {
  const { notifications } = data;

  return {
    ...data,
    notifications: notifications.map((notification) => ({
      ...notification,
      id: notification.notificationId
        ? `${notification.notificationId}_${notification.eventTypeId}`
        : `${BANNER_ID}_${notification.eventTypeId}`,
    })),
  };
}
